// extracted by mini-css-extract-plugin
export default {"checked":"ULkNxqzU1r_uk_LKNt5m","title":"z3Tf4XBINE8QHpgrulQK"};